import { InjectionToken } from '@angular/core';
import { FeatureFlagConfig } from '../../models/feature-flag-config/feature-flag-config.model';

export const FEATURE_FLAG = new InjectionToken<FeatureFlagConfig>(
    'featureFlag',
);
